<div class="flex flex-col bg-white font-[inherit]">
  <!-- Top Navigation Items -->
  <nav class="mb-4 flex flex-col">
    <button
      type="button"
      data-testid="account-nav-button"
      [class]="ui.navButton"
      [class.justify-center]="collapseSidebar()"
      aria-label="Settings"
      (click)="settingsClick.emit()"
    >
      <app-feather-icons [class]="ui.navIcon" [class.mr-4]="!collapseSidebar()" icon="settings"></app-feather-icons>
      @if (!collapseSidebar()) {
      <span [class]="ui.navLabel">Settings</span>
      }
    </button>

    <button
      type="button"
      data-testid="account-nav-button"
      [class]="ui.navButton"
      [class.justify-center]="collapseSidebar()"
      aria-label="Get Help"
      (click)="getHelpClick.emit()"
    >
      <app-feather-icons [class]="ui.navIcon" [class.mr-4]="!collapseSidebar()" icon="help-circle"></app-feather-icons>
      @if (!collapseSidebar()) {
      <span [class]="ui.navLabel">Get Help</span>
      }
    </button>

    <button
      type="button"
      data-testid="account-nav-button"
      [class]="ui.navButton"
      [class.justify-center]="collapseSidebar()"
      aria-label="Search"
      (click)="searchClick.emit()"
    >
      <app-feather-icons [class]="ui.navIcon" [class.mr-4]="!collapseSidebar()" icon="search"></app-feather-icons>
      @if (!collapseSidebar()) {
      <span [class]="ui.navLabel">Search</span>
      }
    </button>
  </nav>

  <!-- Account Footer Card -->
  <div
    class="mt-auto flex items-center p-4"
    [class.justify-between]="!collapseSidebar()"
    [class.justify-center]="collapseSidebar()"
  >
    <div class="flex items-center overflow-hidden">
      @if (collapseSidebar()) {
      <button
        type="button"
        data-testid="account-avatar-button"
        class="cursor-pointer rounded-[50%] btn-bare leading-[0]"
        aria-label="Account options"
        aria-haspopup="true"
        [attr.aria-expanded]="menuOpen()"
        (click)="toggleMenu()"
      >
        <img [src]="user().avatarUrl" [alt]="user().name" class="size-10 rounded-[50%] object-cover" />
      </button>
      } @else {
      <img [src]="user().avatarUrl" [alt]="user().name" class="mr-4 size-10 rounded-[50%] object-cover" />
      <div data-testid="account-user-info" class="flex flex-col truncate">
        <span data-testid="account-name" class="truncate text-[14px] leading-[1.2] font-bold text-bs-dark"
          >{{ user().name }}</span
        >
        <span data-testid="account-email" class="truncate text-[13px] text-muted">{{ user().email }}</span>
      </div>
      }
    </div>

    <!-- Three Dots Dropdown (opens above, aligned to the right edge of the trigger) -->
    <div class="relative shrink-0">
      @if (!collapseSidebar()) {
      <button
        type="button"
        data-testid="account-menu-trigger"
        [class]="ui.menuTrigger"
        aria-label="Account options"
        aria-haspopup="true"
        [attr.aria-expanded]="menuOpen()"
        (click)="toggleMenu()"
      >
        <app-feather-icons [class]="ui.icon20" icon="more-vertical"></app-feather-icons>
      </button>
      }

      <div
        data-testid="account-menu"
        role="menu"
        [class]="ui.menu"
        [class.hidden]="!menuOpen()"
        [class.right-0]="!collapseSidebar()"
        [class.left-0]="collapseSidebar()"
      >
        <button type="button" [class]="ui.menuItem" role="menuitem" (click)="onLogOut()">
          <app-feather-icons class="mr-2" icon="log-out"></app-feather-icons>
          <span>Log out</span>
        </button>
      </div>
    </div>
  </div>
</div>
